// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2hhpg","resendInfoText":"OnGoingPaymentBox_resendInfoText__2GOf8"};